import { ListProps, Paging } from '@Core';
import { CameraPriority, Location } from '@EcamModel/model';

export interface IGetLocationProps extends ListProps<Location> {
    CompanyId?: number;
    RegionId?: number;
    PortfolioId?: number;
    Mac?:string;
    IncludeECStats?: boolean;
}

export enum CameraIssues {
    OutOfBattery,
    SdCardError,
    IncorrectAngle,
}

export interface IGetPaginationWithCameras extends ListProps<Location> {
    CameraIssues?: CameraIssues;
    CameraPriority?: CameraPriority;
}

export interface ILocationHttpController {
    list(props: IGetLocationProps): Promise<Paging<Location>>;
    getPaginationWithCameras(props: IGetPaginationWithCameras): Promise<Paging<Location>>;
}
